import timg1 from '../images/team/sa-team02.png'
import timg2 from '../images/team/sa-team03.png'
import timg3 from '../images/team/sa-team01.png'
import timg4 from '../images/team/sa-team04.png'
import timg5 from '../images/team/sa-team05.png'
import timg6 from '../images/team/sa-team06.png'
import timg7 from '../images/team/sa-team07.png'
import timg8 from '../images/team/sa-team08.png'
import timg9 from '../images/team/sa-team09.png'
import timg10 from '../images/team/sa-team10.png'
import timg11 from '../images/team/sa-team11.png'
import timg12 from '../images/team/sa-team12.png'


const Teams = [
   {
      Id: '1',
      tImg: timg1,
      name: 'James anderson',
      slug: 'James-anderson',
      title: 'Technical SEO Specialist',
      exprience:'15 Years experience',
      rating:'4.9',
   },
   {
      Id: '2',
      tImg: timg2,
      name: 'David wilson',
      slug: 'David wilson',
      title: 'SEO Project Manager',
      exprience:'18 Years experience',
      rating:'4.8',
   },
   {
      Id: '3',
      tImg: timg3,
      name: 'Sophia turner',
      slug: 'Sophia turner',
      title: 'Link Building Manager',
      exprience:'10 Years experience',
      rating:'4.5',
   },
   {
      Id: '4',
      tImg: timg4,
      name: 'Natalie brooks',
      slug: 'Natalie brooks',
      title: 'Senior SEO Strategist',
      exprience:'18 Years experience',
      rating:'4.9',
   },
   {
      Id: '5',
      tImg: timg5,
      name: 'Brian johnson',
      slug: 'Brian johnson',
      title: 'Business Developer',
      exprience:'20 Years experience',
      rating:'4.8',
   },
   {
      Id: '6',
      tImg: timg6,
      name: 'Maverick Phoenix',
      slug: 'Maverick-Phoenix',
      title: 'data analyst',
      exprience:'15 Years experience',
      rating:'4.9',
   },
   {
      Id: '7',
      tImg: timg7,
      name: 'James anderson',
      slug: 'James-anderson',
      title: 'Technical SEO Specialist',
      exprience:'15 Years experience',
      rating:'4.9',
   },
   {
      Id: '8',
      tImg: timg8,
      name: 'David wilson',
      slug: 'David wilson',
      title: 'SEO Project Manager',
      exprience:'18 Years experience',
      rating:'4.8',
   },
   {
      Id: '9',
      tImg: timg9,
      name: 'Sophia turner',
      slug: 'Sophia turner',
      title: 'Link Building Manager',
      exprience:'10 Years experience',
      rating:'4.5',
   },
   {
      Id: '10',
      tImg: timg10,
      name: 'Natalie brooks',
      slug: 'Natalie brooks',
      title: 'Senior SEO Strategist',
      exprience:'18 Years experience',
      rating:'4.9',
   },
   {
      Id: '11',
      tImg: timg11,
      name: 'Brian johnson',
      slug: 'Brian johnson',
      title: 'Business Developer',
      exprience:'20 Years experience',
      rating:'4.8',
   },
   {
      Id: '12',
      tImg: timg12,
      name: 'Maverick Phoenix',
      slug: 'Maverick-Phoenix',
      title: 'data analyst',
      exprience:'15 Years experience',
      rating:'4.9',
   },
   
]

export default Teams;